import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import PositionList from "./PositionList";
import UpsertPositionModal from "./UpsertPositionModal";
import { ChangeIsUpdateOperation, ShowUpsertPositionModal } from "../Store";
import Overlay from "../../../SharedComponents/Overlay";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import IconSvg from "../../../SharedComponents/IconSvg";
import ScrollableCard from "../../../SharedComponents/ScrollableCard";
import { getPositionsByCompanyId } from "../Store/Thunk";
import { Card } from "react-bootstrap";
import { getAllJobLevels, getAllJobGroups, getAllDepartments } from "../../../SuperAdmin/Organization/Store/Thunk";

export default function CreatePosition() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.position.isLoading);
  const companyId = useSelector((state) => state.auth.user.companyUser.company.companyId);
  const positionList = useSelector((state) => state.createPosition.positionList);

  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(getPositionsByCompanyId({ id: companyId }));
    dispatch(getAllJobLevels());
    dispatch(getAllJobGroups());
    dispatch(getAllDepartments());
  }, [dispatch, companyId]);

  const FilteredPositionList = () => {
    return positionList.filter((position) => {
      const matchesName = searchInput ? position.name.toLowerCase().includes(searchInput.toLowerCase()) : true;
      const matchesId = searchInput ? position.id.toString().includes(searchInput.toLowerCase()) : true;
      return matchesName || matchesId;
    });
  };

  const HandleCreateClick = () => {
    dispatch(ChangeIsUpdateOperation({ isUpdateOperation: false }));
    dispatch(ShowUpsertPositionModal({ upsertPositionModalIsShown: true }));
  };
  return (
    <div>
      {isLoading && <Overlay />}

      <Form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Row className={"justify-content-between mx-0"}>
          <Col xs={12} sm={true} className={"align-content-center"}>
            <Form.Control
              placeholder={t("searchPositionLabel")}
              style={{ height: "46px" }}
              className={"default-text-input white-bg"}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            ></Form.Control>
          </Col>
          <Col xs={12} sm={"auto"} className={"align-content-center mt-sm-0 mt-2"}>
            <Button className={"button secondary w-100"} onClick={HandleCreateClick}>
              <Row>
                <Col xs={"auto"} className={"align-content-center"}>
                  <IconSvg icon={"plusV2"} height={22} width={22}></IconSvg>
                </Col>
                <Col xs={"auto"} className={"text-20 fw-medium"}>
                  {t("createNewPositionButtonLabel")}
                </Col>
              </Row>
            </Button>
          </Col>
        </Row>
      </Form>

      <ScrollableCard>
        <PositionList positionList={FilteredPositionList()}></PositionList>
        {FilteredPositionList().length === 0 && (
          <Row className={"mx-0 mt-3"}>
            <Col xs={12} md={6} xl={4} xxl={3} xxxl={2} className="mb-4">
              <Card className="default-card unavailable">
                <div className="d-flex flex-column p-3 " style={{ minHeight: "330px" }}>
                  <Row className="justify-content-center mt-3">
                    <Col xs="auto">
                      <IconSvg icon="shopping-bag" width={52} height={52} fill={"#8b8c89"} />
                    </Col>
                  </Row>

                  <Row>
                    <Col className="text-center text-32 text-color-gray-light fw-medium mt-4">
                      {searchInput ? t("noPositionsFound") : t("noPositionsAddedYet")}
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
        )}
      </ScrollableCard>
      <UpsertPositionModal companyId={companyId}></UpsertPositionModal>
    </div>
  );
}
